// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1HCNS","messages":"Chat_messages__28Sb2","dateDivider":"Chat_dateDivider__2EfOS"};